import styled from 'styled-components';
import { NHColor } from 'ui-kit';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1200;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const Wrapper = styled.div`
  position: fixed;
  top: 90px;
  right: 40px;
  z-index: 1300;
  width: 340px;
  max-width: calc(100vw - 40px);
  background-color: ${NHColor.white};
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08);

  &::before {
    content: '';
    position: absolute;
    top: -8px;
    right: 40px;
    width: 16px;
    height: 16px;
    background-color: ${NHColor.white};
    transform: rotate(45deg);
  }

  @media (max-width: 600px) {
    top: 100px;
    right: 16px;
    left: 16px;
    width: auto;
    max-width: none;

    &::before {
      right: 24px;
    }
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  color: ${NHColor.charcoal500};
`;
